import React, { useState, useEffect, Fragment } from "react"
import styled from "styled-components"
import colors from "../../styles/colors"
import { graphql, useStaticQuery } from "gatsby"
import { getLocalisedContent } from "../../services/contentful"
import PromoBanner from "../Core/Header/PromoBanner"
import MobileHeader from "../Core/Header/MobileHeader"
import MiniCart from "../MiniCart/MiniCart"
import MobileOverlay from "../Core/Header/MobileOverlay"
import breakpoints from "../../styles/breakpoints"
import DesktopHeader from "../Core/Header/DesktopHeader"
import DesktopOverlay from "../Core/Header/DesktopOverlay"
import { isBrowser, setBodyOverflow } from "../../services/browser"
import { getUserToken } from "../../services/user/user"
import { connect } from "react-redux"
import { isToggleBasket } from "../../store/reducers"
import { LOGIN_FORM, RESET_PASSWORD_FORM } from "../../context/form/formTypes"
import { useFormContext } from "../../context/form/FormContext"

const HeaderContainer = styled.div`
  background: ${colors.white};
  position: relative;
  z-index: 999;
  display: grid;
  max-width: 100vw;
  overflow: hidden;
`

const MobilePromoBanner = styled.div`
  display: block;
  background: ${colors.globalgreen};

  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`

const DesktopPromoBanner = styled.div`
  display: none;
  background: ${colors.globalgreen};

  @media (min-width: ${breakpoints.lg}) {
    display: block;
    
  }
`

const HeaderWrapper = styled.div`
  order: 0;
  @media (min-width: ${breakpoints.lg}) {
    order: 1;
  }
`

const Header = ({
  isBespokeOpen,
  setIsBespokeOpen,
  alternatePath,
  handleAccountPopup,
  isAccountPopupOpen,
  isToggleBasket,
}) => {
  const data = useStaticQuery(
    graphql`
      query {
        promoBanner: allContentfulPromoBanner(
          filter: { enabled: { eq: true } }
        ) {
          nodes {
            locale
            node_locale
            slides {
              bannerText {
                raw
              }
            }
          }
        }
        navigations: allContentfulNavigation(
          filter: { navigationId: { eq: "navigation" } }
        ) {
          nodes {
            node_locale
            mobile {
              __typename
              ... on ContentfulLink {
                id
                link
                locale
                title
                openBespokeForm
                isFeatured
                externalLink
              }
              ... on ContentfulLinkList {
                id
                locale
                header
                links {
                  ... on ContentfulLinkList {
                    id
                    locale
                    links {
                      ... on ContentfulLink {
                        id
                        link
                        title
                        locale
                        openBespokeForm
                        externalLink
                        isFeatured
                      }
                    }
                  }
                }
              }
            }
            desktop {
              __typename
              ... on ContentfulLink {
                id
                link
                locale
                title
                openBespokeForm
                externalLink
                isFeatured
              }
              ... on ContentfulLinkList {
                id
                locale
                header
                headerLink
                links {
                  ... on ContentfulLink {
                    id
                    link
                    locale
                    title
                    openBespokeForm
                    externalLink
                    isFeatured
                    thumbnail {
                      gatsbyImageData
                    }
                  }
                  ... on ContentfulLinkList {
                    id
                    header
                    locale
                    links {
                      ... on ContentfulLink {
                        id
                        link
                        title
                        locale
                        openBespokeForm
                        externalLink
                        isFeatured
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  const [cartOpen, setCartOpen] = useState(false)
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const [activeTab, setActiveTab] = useState(null)
  const { promoBanner, navigations } = data
  const localisedPromoBanners = getLocalisedContent(promoBanner.nodes)
  const localisedNavigation = getLocalisedContent(navigations.nodes)
  const { setContent } = useFormContext()

  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"

  let activeBanners = []

  if (localisedPromoBanners && localisedPromoBanners.length > 0) {
    const currentLocal = activeEnv === "staging" ? "us" : activeEnv
    localisedPromoBanners.forEach((banner) => {
      if (banner.locale && banner.locale.includes(currentLocal.toUpperCase())) {
        activeBanners.push(banner)
      }
    })
  }

  const handleAccountClick = () => {
    const token = getUserToken()

    if (token && isBrowser()) {
      let urlWithPrefix =
        process.env.WEBSITE_URL_WITH_PREFIX || process.env.WEBSITE_URL || ""
      if (urlWithPrefix.endsWith("/")) {
        urlWithPrefix = urlWithPrefix.slice(0, urlWithPrefix.length - 1)
      }
      window.location.href = `${urlWithPrefix}/account`
      return
    }
    handleAccountPopup(!isAccountPopupOpen)
  }

  useEffect(() => {
    if (isToggleBasket === true && !cartOpen) {
      setCartOpen(true)
    }
  }, [isToggleBasket, cartOpen])

  useEffect(() => {
    if (mobileNavOpen) {
      setBodyOverflow(true)
    } else {
      setBodyOverflow(false)
    }
  }, [mobileNavOpen])

  useEffect(() => {
    if (isBrowser()) {
      if (
        window.location.search &&
        window.location.search.includes("reset-password-token")
      ) {
        setContent(RESET_PASSWORD_FORM)
        handleAccountPopup(true)
      }
    }
    if (isBrowser()) {
      if (
        window.location.search &&
        window.location.search.includes("email-confirmation")
      ) {
        setContent(LOGIN_FORM)
        handleAccountPopup(true)
      }
      if (
        window.location.search &&
        window.location.search.includes("email-confirmation")
      ) {
        setContent(LOGIN_FORM)
        handleAccountPopup(true)
      }
      if (
        window.location.search &&
        window.location.search.includes("?ref_discount_code=")
      ) {
        const referralCode =
          window.location.search.split("ref_discount_code=")[1]
        sessionStorage.setItem("friendCode", referralCode)
      }
    }
  }, [handleAccountPopup])

  const closeIfActive = (e) => {
    setBodyOverflow(false)
    if (e.currentTarget.className.includes("active")) {
      e.preventDefault()
      setMobileNavOpen(false)
    }
  }

  return (
    <Fragment>
      <DesktopPromoBanner>
        <PromoBanner
          banners={activeBanners}
          visible={cartOpen || mobileNavOpen ? false : true}
          alternatePath={alternatePath}
        />
      </DesktopPromoBanner>
      <div style={{ position: "sticky", top: "0", zIndex: "999" }}>
        <HeaderContainer>
          <HeaderWrapper>
            <MobileHeader
              cartOpen={cartOpen}
              setCartOpen={setCartOpen}
              menuOpen={mobileNavOpen}
              setMenuOpen={setMobileNavOpen}
              handleAccountClick={handleAccountClick}
            />
            <DesktopHeader
              nav={localisedNavigation?.[0]?.desktop}
              cartOpen={cartOpen}
              setCartOpen={setCartOpen}
              isBespokeOpen={isBespokeOpen}
              setIsBespokeOpen={setIsBespokeOpen}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              handleAccountClick={handleAccountClick}
            />
          </HeaderWrapper>
          <MobilePromoBanner>
            <PromoBanner
              banners={activeBanners}
              visible={cartOpen || mobileNavOpen ? false : true}
              alternatePath={alternatePath}
            />
          </MobilePromoBanner>
        </HeaderContainer>
        {cartOpen && <MiniCart open={cartOpen} handleOpen={setCartOpen} />}
        {mobileNavOpen && (
          <MobileOverlay
            links={localisedNavigation?.[0]?.mobile}
            isBespokeOpen={isBespokeOpen}
            setIsBespokeOpen={setIsBespokeOpen}
            setMenuOpen={setMobileNavOpen}
            closeIfActive={closeIfActive}
            alternatePath={alternatePath}
          />
        )}
        <DesktopOverlay
          links={localisedNavigation?.[0]?.desktop}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isBespokeOpen={isBespokeOpen}
          setIsBespokeOpen={setIsBespokeOpen}
        />
      </div>
    </Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    isToggleBasket: isToggleBasket(state),
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
